import { useState, useEffect } from 'react';
import { FamiliarisationPhase, NeuroSuiteTest, NeuroSuiteResults, EyeMotilityPhase } from '..';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';
import { StepBody, useTestStepSync } from '../testScreenKit';

const NeuroSuite = ({ setTitle, setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const [step, setStep] = useState('eyeMotility');
  const postMessage = usePostMessage();
  useTestStepSync(testData.testKey, step);

  useEffect(() => {
    postMessage({ type: 'visualFieldForthValley' });
    updateTestData({ testInProgress: true, visualFieldForthValley: { patientInputMethod: 'opticianControl' } });
  }, [postMessage, updateTestData]);

  useEffect(() => {
    switch (step) {
      case 'eyeMotility':
        return setTitle('Eye Motility');
      // case 'setPatientInputMethod':
      //   setTitle('Select Patient Input Method');
      //   break;
      case 'familiarisationPhase':
        return setTitle('Landolt C Familiarisation');
      case 'neuroSuiteTest':
        return setTitle('Neurological Suite Test');
      case 'results':
        return setTitle('Neurological Suite Results');
      default:
        break;
    }
  }, [setTitle, step, updateTestData]);

  const updateStep = (selectedStep) => {
    postMessage({ type: 'navigationMessage', content: selectedStep });
    setStep(selectedStep);
  };

  const renderSwitch = () => {
    switch (step) {
      case 'eyeMotility':
        return <EyeMotilityPhase updateStep={updateStep} />;
      // case 'setPatientInputMethod':
      //   return <SetPatientInputMethod />;
      case 'familiarisationPhase':
        return <FamiliarisationPhase updateStep={updateStep} />;
      case 'neuroSuiteTest':
        return <NeuroSuiteTest updateStep={updateStep} />;
      case 'results':
        return <NeuroSuiteResults localResults={testData} setActiveTab={setActiveTab} updateStep={updateStep} />;
      default:
        return;
    }
  };

  return (
    <StepBody data-testid='neuro-suite' data-step={step}>
      {renderSwitch()}
    </StepBody>
  );
};

export default NeuroSuite;
